import React from "react";

/**
 * Orange ring spinner (Kinetic Precision). Uses Tailwind's animate-spin.
 * size: "sm" | "md" | "lg"
 */
const sizes = {
  sm: "h-5 w-5 border-2",
  md: "h-8 w-8 border-4",
  lg: "h-12 w-12 border-4",
};

const Spinner = ({ size = "md", className = "" }) => (
  <span role="status" aria-live="polite" className={`inline-flex ${className}`}>
    <span
      className={`${sizes[size] || sizes.md} animate-spin rounded-full border-primary-container/30 border-t-primary-container`}
    />
    <span className="sr-only">Loading…</span>
  </span>
);

export default Spinner;
